import { render, staticRenderFns } from "./TableFieldConfiguratorTranslations.vue?vue&type=template&id=1cbcdc00&"
import script from "./TableFieldConfiguratorTranslations.vue?vue&type=script&lang=js&"
export * from "./TableFieldConfiguratorTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports